import React from 'react';

import ErrorPage from './ErrorPage';

function NotFoundPage() {
  return <ErrorPage title="Oops!" text="404 Page not found" />;
}

export default NotFoundPage;
